import { render, staticRenderFns } from "./CredentialStorageSave.vue?vue&type=template&id=5a572512&scoped=true&"
import script from "./CredentialStorageSave.vue?vue&type=script&lang=js&"
export * from "./CredentialStorageSave.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5a572512",
  null
  
)

export default component.exports